import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { scrollToElement } from '@/utils/scroll';
import { FakeDropdown } from '../FakeDropdown/FakeDropdown';

@Component
export class FaqContainer extends ThemeComponent {

    @Ref categoryButton!: HTMLButtonElement[];
    @Ref categoryContainer!: HTMLElement[];
    @Ref categoryDropdown!: FakeDropdown;

    init() {

        // Listen for category button click
        this.listenForCategoryButtonClick();

        // Listen for category dropdown change
        this.listenForCategoryDropdownChange();
    }

    listenForCategoryButtonClick() {
        for (const categoryButton of this.categoryButton) {
            this.$listen(categoryButton, 'click', () => {

                // Get category title
                const categoryTitle = categoryButton.getAttribute('data-category-title');

                // Find matching category container - scroll to
                for (const categoryContainer of this.categoryContainer) {
                    const containerCategoryTitle = categoryContainer.getAttribute('data-category-title');
                    if (containerCategoryTitle === categoryTitle) {
                        scrollToElement(categoryContainer, true);
                    }
                }
            });
        }
    }

    listenForCategoryDropdownChange() {
        this.$subscribe(this.categoryDropdown.onChange, (value) => {

            // Find matching category container - scroll to
            for (const categoryContainer of this.categoryContainer) {
                const containerCategoryTitle = categoryContainer.getAttribute('data-category-title');
                if (containerCategoryTitle === value) {
                    scrollToElement(categoryContainer, true);
                }
            }
        });
    }
}
